const LOCAL_STORAGE = {
  // TODO: change to promobit.access-token
  ACCESS_TOKEN: 'apiToken',
  IS_POLICY_NUMBER_1_ACCEPTED: 'police.cookie_1',
  IS_POLICY_NUMBER_2_ACCEPTED: 'police.cookie_2',
  IS_POLICY_NUMBER_3_ACCEPTED: 'police.cookie_3',
  IS_POLICY_NUMBER_5_ACCEPTED: 'police.cookie_5',
  IS_SHOWING_LGPD_ALERT: 'police.show_modal',
  LAST_COMMENT_KEY: 'prs.last_comment_key',
  LAST_COUPON_KEY: 'prs.last_coupon_key',
  LAST_FORUM_KEY: 'prs.last_forum_key',
  LOGGED_IN_USER: 'loggedInUser',
  // Promobit 2.0
  IS_APPS_DIALOG_ACTIVE: 'promobit.is-apps-dialog-active',
  IS_APPS_DIALOG_ACTIVE_HOME_AB_TEST:
    'promobit.is-apps-dialog-active-home-ab-test',
  IS_DOWNLOAD_APP_CTA_COMPONENT_HOME_AB_TEST_ACTIVE:
    'promobit.is-download-app-cta-component-home-ab-test',
  IS_DARK_MODE_ACTIVE: 'promobit.is-dark-mode-active',
  IS_EXTENSION_ACTIVE: 'promobit_extensions',
  IS_ON_BOARD_FILTER_TOOLTIP_ENABLED:
    'promobit.is-on-board-filter-tooltip-enabled',
  IS_SUPIX_COLLECTED: 'promobit.is-supix-collected',
  IS_INTERNATIONAL_OFFERS_ACTIVE: 'promobit.is-international-offers-active',
  NOTIFICATION_ONBOARDING_STATUS: 'promobit.notification-onboarding-status',
  SHOULD_RELOAD_ON_LOGOUT: 'promobit.should-reload-on-logout',
  SHOWED_WELCOME_NOTIFICATION: 'showedWelcomeNotification',
  USER_UTM_CAMPAIGN: 'promobit.user-utm-campaign',
  SHOWED_SHARE_CAMPAIGN_LOGIN_MODAL:
    'promobit.showed-share-campaign-login-modal',
  WEBPUSH_HASH: 'webpush-hash',
  IS_WISHLIST_MAINTENANCE_ALREADY_INTERACTED:
    'promobit.is-wishlist-maintenance-already-interacted',
};

export default LOCAL_STORAGE;
